import React from 'react';
import { useAuth } from '../context/AuthContext';

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v.toDate === 'function') return v.toDate();
  if (typeof v === 'number') return new Date(v);
  if (typeof v === 'string') { const d = new Date(v); return isNaN(d) ? null : d; }
  if (v.seconds != null) return new Date(v.seconds * 1000);
  return null;
}

export default function PilotExpirationBanner() {
  const { org } = useAuth() || {};
  if (!org || org.plan !== 'pilot') return null;

  const expiresAt = toDate(org.pilotExpiresAt);
  if (!expiresAt) return null;

  const msLeft = expiresAt.getTime() - Date.now();
  const daysLeft = Math.ceil(msLeft / (24 * 60 * 60 * 1000));
  const expired = msLeft <= 0;

  const tier = expired ? 'expired' : daysLeft <= 7 ? 'critical' : daysLeft <= 14 ? 'warning' : 'info';
  const palette = {
    info:     { bg: '#f59e0b14', border: '#f59e0b55', text: '#f59e0b' },
    warning:  { bg: '#f59e0b22', border: '#f59e0b88', text: '#fbbf24' },
    critical: { bg: '#f8717122', border: '#f8717188', text: '#f87171' },
    expired:  { bg: '#f8717133', border: '#f87171',   text: '#f87171' },
  }[tier];

  const message = expired
    ? `Your pilot expired on ${expiresAt.toLocaleDateString()}. Contact your organization admin to upgrade and restore full access.`
    : `Your pilot expires in ${daysLeft} day${daysLeft === 1 ? '' : 's'} (${expiresAt.toLocaleDateString()}). Contact your organization admin to upgrade before access is restricted.`;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
      padding: '8px 16px', background: palette.bg,
      borderBottom: `1px solid ${palette.border}`,
      color: palette.text, fontSize: 13, fontWeight: 600, letterSpacing: 0.2,
    }}>
      <span style={{
        background: palette.text, color: '#060d18', fontSize: 10, fontWeight: 700,
        padding: '2px 8px', borderRadius: 10, letterSpacing: 0.5,
      }}>
        {expired ? 'EXPIRED' : 'PILOT'}
      </span>
      <span style={{ color: '#e2e8f0' }}>{message}</span>
    </div>
  );
}
